import { isTabInFocus, removeStateFromUrl } from '@shared/utils/utils';
import { PageStateService } from '@shared/user-state/PageStateService';
import { Events, EventsGlobal } from '@shared/Events';

/**
 * @author NikolaV
 */
export class PageStateLiveUserState<T extends IPageState> {
    handler: IPageStateHandler<T> = null;

    lastState: IPageState = null;
    checkChangeTimer = null;

    constructor(handler: IPageStateHandler<T>) {
        this.handler = handler;
        Events.on(EventsGlobal.PROJECT_CHANGE_BEFORE, this.saveNow);
    }

    startPolling = (checkChangeIntervalMS: number) => {
        clearInterval(this.checkChangeTimer);
        this.checkChangeTimer = setInterval(this.save, checkChangeIntervalMS);
    };

    equals(a: IPageState, b: IPageState): boolean {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    restoreState = (page: IPageStatePage) => {
        const req = PageStateService.liveState.fetch(page);
        req.then(state => {
            this.handler.restoreState(state);
        });
        return req;
    };

    save = async () => {
        if (!isTabInFocus()) return;
        return this.saveNow();
    };

    saveNow = async (): Promise<void> => {
        const currState = await this.handler.getCurrentState(false);

        if (this.lastState == null) {
            // first run
            this.lastState = currState;
        }

        if (!this.equals(currState, this.lastState)) {
            return PageStateService.liveState.saveOrUpdate(currState).always(() => {
                this.lastState = currState;

                // remove share key from url (after the state is changed) so that user can refresh the page normally
                removeStateFromUrl();
            });
        }
    };

    stopPolling = () => {
        clearInterval(this.checkChangeTimer);
    };
}
